import React, {useEffect} from "react";
import {Breadcrumbs} from "@mui/material";
import classNames from "classnames";
import {useCategory} from "@/features/article/model/useCategory";
import {usePagination} from "@/features/article/model/usePagination";
import {formatDMY} from "@/shared/lib/date";
import {useArticleStore} from "@/Stores/Site/Article";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import {lazyWithPreload} from "@/Helpers/lazyWithPreload";
import LazySection from "@/Components/LazySection";
import "@/Scss/Site/News/index.scss";

const Pagination = lazyWithPreload(() => import('@/Components/Site/Pagination'));

const Index = (props) => {
    const {newsData = [], isMobile = false} = props;
    const {news = [], categories = [], categoryId = 1, countNews = 0, page = 1, perPageStart = 12} = newsData;

    const initData = useArticleStore(state => state.initData);

    const {changeCategory} = useCategory({
        source: 'news',
        categoryId
    });
    const {changePage} = usePagination({
        source: 'news',
        categoryId,
        page,
        perPage: perPageStart
    });

    useEffect(() => {
        initData(newsData);
    }, [categoryId, page]);

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                <div className={`container`}>
                    <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                        <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                        <p className={`breadcrumbs__text`}>Новости</p>
                    </Breadcrumbs>
                    <h1 className={`h1`}>Новости</h1>
                    <div className={`newsPage`}>
                        <div className={`newsPage__navigations`}>
                            {categories.map((el) => {
                                return (
                                    <p
                                        key={el.id}
                                        className={classNames('newsPage__navigationItem', {'newsPage__navigationItem--active': el.id === categoryId})}
                                        onClick={() => changeCategory(el.id)}
                                    >
                                        {el.category}
                                    </p>
                                );
                            })}
                        </div>
                        <div className={`newsPage__articles`}>
                            {news.length === 0 && (
                                <p className={`newsPage__noArticles`}>В данной категории отсутствуют новости.</p>
                            )}
                            {news.length > 0 && (
                                <>
                                    {news.map((el) => {
                                        return (
                                            <Link
                                                href={`/news/${el.url}`} key={el.id}
                                                className={`newsPage__articleItem`}
                                            >
                                                <Picture
                                                    src={el.imgPreview}
                                                    alt={el.h1}
                                                    title={el.h1}
                                                    imageClassName={`increase`}
                                                />
                                                <div className={`newsPage__articleItemContent`}>
                                                    <p className={`newsPage__articleItemCategory`}>{el.category}</p>
                                                    <p className={`newsPage__articleItemTitle`}>{el.h1}</p>
                                                    <p className={`newsPage__articleItemDate`}>
                                                        {formatDMY(el.published_at)}
                                                    </p>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                        <LazySection>
                            <Pagination
                                activePage={page}
                                itemsCountPerPage={perPageStart}
                                totalItemsCount={countNews}
                                pageRangeDisplayed={isMobile ? 3 : 10}
                                onChange={changePage}
                                hideFirstLastPages={isMobile}
                            />
                        </LazySection>
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
};

export default Index;
